import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ANALYTICS_CONFIG, trackPageView } from '../../config/analytics';

/**
 * Componente Analytics
 *
 * Injeta scripts de Google Analytics 4 e Facebook Pixel no head
 * e rastreia mudanças de página automaticamente
 */
const Analytics: React.FC = () => {
  const location = useLocation();

  // Injeta scripts no head quando o componente monta
  useEffect(() => {
    // Verificar se estamos no browser
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    // Google Analytics 4
    if (ANALYTICS_CONFIG.googleAnalytics.enabled) {
      const gaScript1 = document.createElement('script');
      gaScript1.async = true;
      gaScript1.src = `https://www.googletagmanager.com/gtag/js?id=${ANALYTICS_CONFIG.googleAnalytics.measurementId}`;
      document.head.appendChild(gaScript1);

      const gaScript2 = document.createElement('script');
      gaScript2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${ANALYTICS_CONFIG.googleAnalytics.measurementId}', {
          send_page_view: false
        });
      `;
      document.head.appendChild(gaScript2);

      if (import.meta.env.DEV) {
        console.log(' Google Analytics 4 inicializado');
      }
    }

    // Facebook Pixel
    if (ANALYTICS_CONFIG.facebookPixel.enabled) {
      const fbScript = document.createElement('script');
      fbScript.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${ANALYTICS_CONFIG.facebookPixel.pixelId}');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(fbScript);

      if (import.meta.env.DEV) {
        console.log(' Facebook Pixel inicializado');
      }
    }

    if (import.meta.env.DEV && !ANALYTICS_CONFIG.googleAnalytics.enabled && !ANALYTICS_CONFIG.facebookPixel.enabled) {
      console.log(' Analytics desabilitado - Configure os IDs em src/config/analytics.ts');
    }
  }, []);

  // Rastreia mudanças de página
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }
    const pageTitle = document.title;
    trackPageView(location.pathname, pageTitle);
  }, [location]);

  // Componente não renderiza nada
  return null;
};

export default Analytics;
